import React, { useState, useEffect, useRef } from "react";
import { Volume2, VolumeX } from "lucide-react";

const MusicPlayer: React.FC = () => {
  const [isMusicPlaying, setIsMusicPlaying] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    // Try to start muted autoplay
    audio.muted = true;
    audio.play().catch(() => console.log("Muted autoplay was blocked."));
  }, []);

  const handleMusic = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (!hasInteracted) {
      setHasInteracted(true);
      audio.muted = false;
      setIsMuted(false);
      audio
        .play()
        .then(() => {
          setIsMusicPlaying(true);
        })
        .catch((error) => {
          console.error("Audio playback failed:", error);
          setIsMusicPlaying(false);
          audio.muted = true;
          setIsMuted(true);
        });
    } else {
      if (isMusicPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      setIsMusicPlaying(!isMusicPlaying);
    }
  };

  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (!hasInteracted) {
      handleMusic();
      return;
    }

    audio.muted = !audio.muted;
    setIsMuted(audio.muted);
    setIsMusicPlaying(!audio.muted);
  };

  const IconComponent = isMuted || !isMusicPlaying ? VolumeX : Volume2;

  return (
    <>
      <audio ref={audioRef} loop>
        <source
          src="https://file.catke.com/familyTree/huang.mp3"
          type="audio/mp3"
        />
        Your browser does not support the audio element.
      </audio>

      <button
        onClick={toggleMute}
        className="music-button"
        aria-label="Toggle background music"
      >
        <IconComponent className="text-red-800 w-6 h-6" />
      </button>
    </>
  );
};

export default MusicPlayer;
